import { SYSTEM_VARIABLES } from "@velizhanin-dev/bot-scenario"
import { useState } from "react"
import { Input } from "@/shared/ui/input"
import { NativeSelect } from "@/shared/ui/native-select"

/** Переменная, которую можно выбрать или вставить в текст: минимум для VariableSelect/TextWithVariables. */
export interface SelectableVariable {
	id: string
	name: string
}

export function VariableSelect({
	value,
	onChange,
	variables,
	includeSystem = false,
	emptyLabel,
	id,
	"aria-label": ariaLabel,
}: {
	value: string
	onChange: (value: string) => void
	variables: SelectableVariable[]
	includeSystem?: boolean
	/** Задан: пустое значение разрешено и подписано так. */
	emptyLabel?: string
	id?: string
	"aria-label"?: string
}) {
	const [search, setSearch] = useState("")
	const known =
		variables.some((variable) => variable.name === value) ||
		(includeSystem && SYSTEM_VARIABLES.some((variable) => variable.name === value))
	return (
		<div className="space-y-2">
			<Input
				type="search"
				value={search}
				onChange={(event) => setSearch(event.target.value)}
				placeholder="Найти переменную"
				aria-label="Поиск переменной"
			/>
			<NativeSelect
				id={id}
				aria-label={ariaLabel}
				value={value}
				onChange={(event) => onChange(event.target.value)}
			>
				<option value="" disabled={!emptyLabel}>
					{emptyLabel ?? "Выберите переменную"}
				</option>
				{value && !known ? <option value={value}>{value} (не объявлена)</option> : null}
				{variables.length > 0 ? (
					<optgroup label="Переменные сценария">
						{variables
							.filter(
								(variable) =>
									variable.name === value ||
									variable.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()),
							)
							.map((variable) => (
								<option key={variable.id} value={variable.name}>
									{variable.name}
								</option>
							))}
					</optgroup>
				) : null}
				{includeSystem ? (
					<optgroup label="Системные">
						{SYSTEM_VARIABLES.filter(
							(variable) =>
								variable.name === value ||
								variable.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()),
						).map((variable) => (
							<option key={variable.name} value={variable.name}>
								{variable.name}
							</option>
						))}
					</optgroup>
				) : null}
			</NativeSelect>
		</div>
	)
}
